<template>

    <div class="pl-4 py-2 border border-dashed border-gray-400" :class="slot.status.icon_class">

        <div class="flex items-center">
            <icon :name="slot.status.icon_name"/>
            <span class="inline-block ml-5 text-sm" v-text="slot.status.message"></span>
            <button class="ml-auto mr-5 text-sm underline text-accented focus:outline-none"
                v-if="slot.permissions.changeStatus"
                @click="editingStatus = ! editingStatus"
            >změnit</button>
        </div>

        <div class="mt-4" v-if="editingStatus">
            <button class="btn btn--sm text-succes border-succes" @click="changeReservationStatus('accept')">
                <icon name="check-circle"/>
                Schválit
            </button>
            <button class="btn btn--sm text-erro border-erro" @click="changeReservationStatus('reject')">
                <icon name="x-circle"/>
                Zamítnout
            </button>
        </div>

    </div>

</template>

<script>
export default {
    props: {
        readonly: {
            type: Boolean,
            default: true
        },
        withFollowing: {
            type: Boolean,
            required: true
        },
    },

    data() {
        return {
            slot: this.$store.slot,
            editingStatus: false,
        }
    },

    computed: {
        followingControlIsVisible() {
            return this.slot.permissions.update
                || this.slot.permissions.delete;
        }
    },

    methods: {
        async changeReservationStatus(action) {

            if (action === 'reject') {
                let resolved = await window.Swal.fire({
                    title: 'Opravdu zamítnout?',
                    text: 'Zamítnutá rezervace bude rovnou smazána',
                    icon: 'warning',
                    showCancelButton: true
                });

                if (! resolved.isConfirmed) {
                    return;
                }
            }

            await axios.patch(`/reservations/${this.slot.id}/change-status`, {
                action,
                following: this.withFollowing
            });

            this.$emit('status-changed');
            window.events.$emit('refreshCalendar');
        },
    },
}
</script>
